/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserAccessOrigin {
    Unknown = 'Unknown',
    User = 'User',
    Section = 'Section',
    AdGroup = 'AdGroup',
    Role = 'Role'
}


export function instanceOfUserAccessOrigin(value: any): boolean {
    for (const key in UserAccessOrigin) {
        if (Object.prototype.hasOwnProperty.call(UserAccessOrigin, key)) {
            if (UserAccessOrigin[key as keyof typeof UserAccessOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserAccessOriginFromJSON(json: any): UserAccessOrigin {
    return UserAccessOriginFromJSONTyped(json, false);
}

export function UserAccessOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessOrigin {
    return json as UserAccessOrigin;
}

export function UserAccessOriginToJSON(value?: UserAccessOrigin | null): any {
    return value as any;
}

export function UserAccessOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): UserAccessOrigin {
    return value as UserAccessOrigin;
}

